module.exports = __webpack_public_path__ + "files/1c82cbdfb332f1c52f6b15241cdc49ce.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/animals_nature-1.png
// module id = 508
// module chunks = 76